<template>
  <v-layout align-start justify-center>
    <v-flex class="pa-0 ma-0 two-list-container">
      <v-subheader class="subtitle-2 pa-0 ma-0">
        {{ sourceTitle }} ({{ sourceSearchResultsCount }})
      </v-subheader>
      <v-subheader class="pa-0 select-all-container">
        <v-flex class="justify-start">
          <v-btn v-if="selectedSourceCount < source.length && source.length" plain x-small left elevation="0"
                 class="select-all-button"
                 :disabled="readonly"
                 :style="buttonProps"
                 @click="selectAllSource">
            <span>
              Select all
            </span>
          </v-btn>
          <v-btn v-if="selectedSourceCount == source.length && source.length" plain x-small left elevation="0"
                 class="select-all-button"
                 :disabled="readonly"
                 :style="buttonProps"
                 @click="deSelectAllSource">
            <span>
              Deselect all
            </span>
          </v-btn>
        </v-flex>
        <v-flex class="justify-end text-right">
          Selected ({{ selectedSourceCount }})
        </v-flex>
      </v-subheader>

      <v-text-field v-if="!readonly" :label="sourceSearchLabel" v-model="searchSource" prepend-inner-icon="search" clearable hide-details dense full-width outlined single-line class="two-list-search"></v-text-field>

      <v-list single-line class="pa-0 ma-0 list-group" :loading="currentLoading">
        <v-list-item :disabled="readonly" v-for="(item,key) in sourceSearchResults"
                     v-bind:key="key" :data-id="item.value" :class="'list-item'+ (item.selected ? ' active':'')" @click="selectSource(searchSource?item.inx:key)">
          <v-list-item-content>
            <v-list-item-title v-html="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :disabled="readonly" v-if="sourceSearchResultsCount == 0 && source.length" class="no-items-message">
          <v-list-item-content>
            <v-list-item-title>No results found</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :disabled="readonly" v-if="sourceCount == 0" class="no-items-message">
          <v-list-item-content>
            <v-list-item-title>{{ noSourceMessage }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-flex>
    <v-flex md="auto" class="align-self-center add-remove-button-container">
      <v-btn elevation="0" height="30"
         min-width="114"
         width="114"
         class="select-remove-button"
         :style="buttonProps"
         :disabled="selectedDestinationCount == 0 || readonly"
         :loading='this.currentLoading'
         @click="moveSource">
    <v-icon color="white">
      arrow_back_ios
    </v-icon>
    <v-icon color="white">
      arrow_back_ios
    </v-icon>
    <span :class="['capitalize', 'btn-text', destinationCount == 0 ? '': 'text--white']">
      REMOVE
    </span>
  </v-btn>
  <v-btn elevation="0" height="30"
         min-width="114"
         width="114"
         class="select-add-button"
         :style="buttonProps"
         :disabled="selectedSourceCount == 0 || readonly"
         :loading='this.currentLoading'
         @click="moveDestination">

    <span class="capitalize btn-text">
      ADD
    </span>
    <v-icon color="white">
      arrow_forward_ios
    </v-icon>
    <v-icon color="white">
      arrow_forward_ios
    </v-icon>
  </v-btn>
    </v-flex>
    <v-flex class="pa-0 ma-0 two-list-container">
      <v-subheader class="subtitle-2 pa-0">
        {{ destinationTitle }} ({{ destinationSearchResultsCount }})
      </v-subheader>
      <v-subheader class="pa-0 select-all-container">
        <v-flex class="justify-start">
          <v-btn v-if="selectedDestinationCount < destination.length && destination.length" plain x-small left elevation="0"
                 class="select-all-button"
                 :disabled="readonly"
                 :style="buttonProps"
                 @click="selectAllDestination">
            <span>
              Select all
            </span>
          </v-btn>
          <v-btn v-if="selectedDestinationCount == destination.length && destination.length" plain x-small left elevation="0"
                 class="select-all-button"
                 :disabled="readonly"
                 :style="buttonProps"
                 @click="deSelectAllDestination">
            <span>
              Deselect all
            </span>
          </v-btn>
        </v-flex>
        <v-flex class="justify-end text-right">
          Selected ({{ selectedDestinationCount }})
        </v-flex>
      </v-subheader>

      <v-text-field v-if="!readonly" :label="destinationSearchLabel" v-model="searchDestination" prepend-inner-icon="search" clearable hide-details dense full-width outlined single-line class="two-list-search"></v-text-field>

      <v-list single-line class="pa-0 ma-0 list-group">
        <v-list-item :disabled="readonly" v-for="(item,key) in destinationSearchResults"
                     v-bind:key="key" :data-id="item.value" :class="'list-item'+ (item.selected ? ' active':'')" @click="selectDestination(searchDestination?item.inx:key)">
          <v-list-item-content>
            <v-list-item-title v-html="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :disabled="readonly" v-if="destinationSearchResultsCount == 0 && destination.length" class="no-items-message">
          <v-list-item-content>
            <v-list-item-title>No results found</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :disabled="readonly" v-if="destinationCount == 0" class="no-items-message">
          <v-list-item-content>
            <v-list-item-title>{{ noDestinationMessage }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { orderBy } from 'lodash';

  export default {
    name: 'ResTwoListSelect',
    data: function () {
      return {
        source: [],
        searchSource: '',
        searchDestination: '',
        label: 'text',
        destinationGroup: [],
      }      
    },
    props: {
      listType: {
        type: String,
        default: 'Properties'
      },
      value: {
        type: Array,
        required: true,
        default: function () {
          return []
        }
      },
      allSelectable: {
        type: Array,
        required: true,
        default: function () {
          return []
        }
      },
      readonly: {
        type: Boolean
      }
    },
    computed: {
      ...mapGetters(['currentLoading']),
      buttonProps() {
        return {
          '--background-color': !this.currentLoading ? "#03739c" : '#d1d1d1',
          '--border-color': !this.disabled && !this.currentLoading ? this.borderColor : '#d1d1d1',
          '--border-radius': '10px',
          '--text-color': 'white',
          '--font-size':  '12px',
          '--border-width': '1px',
          '--text-color-disabled': "#a6a6a6"
        }
      },
      destination: {
        get() {
          return orderBy(this.value, 'text');
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      },
      sourceCount() {
        return this.source.length;
      },
      destinationCount() {
        return this.destination.length;
      },
      selectedSourceCount() {
        let selected = this.source.filter(f => f.selected);
        return selected.length;
      },
      selectedDestinationCount() {
        let selected = this.destination.filter(f => f.selected);
        return selected.length;
      },
      sourceSearchResults() {
        return this.source.map((item, inx) => ({ inx, ...item })).filter(item => item[this.label in item ? this.label : 'label'].toLowerCase().includes((this.searchSource === undefined || this.searchSource === null ? '' : this.searchSource).toLowerCase()));
      },
      sourceSearchResultsCount() {
        return this.sourceSearchResults.length;
      },
      destinationSearchResults() {
        return this.destination.map((item, inx) => ({ inx, ...item })).filter(item => item[this.label in item ? this.label : 'label'].toLowerCase().includes((this.searchDestination === undefined || this.searchDestination === null ? '' : this.searchDestination).toLowerCase()));
      },
      destinationSearchResultsCount() {
        return this.destinationSearchResults.length;
      },
      sourceTitle() {
        return 'Available ' + this.listType;
      },
      destinationTitle() {
        return 'Selected ' + this.listType;
      },
      sourceSearchLabel() {
        return 'Search available ' + this.listType;
      },
      destinationSearchLabel() {
        return 'Search selected ' + this.listType;
      },
      noSourceMessage() {
        return 'There are no available ' + this.listType;
      },
      noDestinationMessage() {
        return 'There are no selected ' + this.listType;
      }
    },
    methods: {
      moveDestination: function () {
        let selected = this.source.filter(f => f.selected);
        if (!selected.length) return;
        selected = selected.map(item => ({
          ...item,
          selected: false
        }));
        let destination = [...selected, ...this.destination];
        let source = this.source.filter(f => !f.selected);
        this.searchSource = "";
        this.searchDestination = "";
        this.destination = orderBy(destination, 'text');
        this.source = orderBy(source, 'text');
      },
      moveSource: function () {
        let selected = this.destination.filter(f => f.selected);
        if (!selected.length) return;
        selected = selected.map(item => ({
          ...item,
          selected: false
        }));
        let source = [...selected, ...this.source];
        let destination = this.destination.filter(f => !f.selected);
        this.searchSource = "";
        this.searchDestination = "";
        this.destination = orderBy(destination, 'text');
        this.source = orderBy(source, 'text');
      },
      selectDestination: function (key) {
        let destination = this.destination.map((i, k) => {
          if (k === key) {
            i.selected = !i.selected;
          }
          return i;
        });
        this.destination = destination;
      },
      selectSource: function (key) {
        let source = this.source.map((i, k) => {
          if (k === key) {
            i.selected = !i.selected;
          }
          return i;
        });
        this.source = source;
      },
      selectAllSource: function () {
        let source = this.source.map(item => {
          if (this.sourceSearchResults.map((item) => item['value']).includes(item['value'])) {
            item.selected = true;
          }
            return item;
        });
        this.source = source;
      },
      deSelectAllSource: function () {
        let source = this.source.map(item => {
          if (this.sourceSearchResults.map((item) => item['value']).includes(item['value'])) {
            item.selected = false;
          }
          return item;
        });      
        this.source = source;
      },
      selectAllDestination: function () {
        let destination = this.destination.map(item => {
          if (this.destinationSearchResults.map((item) => item['value']).includes(item['value'])) {
            item.selected = true;
          }
          return item;
        });      
        this.destination = destination;
      },
      deSelectAllDestination: function () {
        let destination = this.destination.map(item => {
          if (this.destinationSearchResults.map((item) => item['value']).includes(item['value'])) {
            item.selected = false;
          }
          return item;
        });      
        this.destination = destination;
      }
    },
    watch: {
      allSelectable: {
        deep: true,
        immediate: true,
        handler() {
          var self = this;
          let filteredItems = self.allSelectable.filter(function (el1) {
            return self.destination.filter(function (el2) {
                return el2.value.replace(/[{}]/g,"").toLowerCase()==el1.value.replace(/[{}]/g,"").toLowerCase(); // this will also handle GUIDs
            }).length == 0
          });
          this.source = orderBy(filteredItems, 'text');
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .two-list-search::v-deep {
    min-height: 30px;
    height: 30px;

    .v-label   {
    font-size: 14px;
    top: 7px;
  }

  .v-input__slot {
    min-height: 30px !important;
    height: 30px !important;
  }

  .v-input__icon {
    min-width: 18px;
    min-height: 18px;
    height: 18px;
    width: 18px;
  }

  .v-icon {
    font-size: 18px;
  }
  }

  .v-text-field--outlined::v-deep {
    border-radius: unset;

    fieldset {
    border-bottom: 0px;
    }
  }

  .v-text-field--outlined.v-input--is-focused::v-deep fieldset {
    border-color: var(--v-resBlue-darken1) !important;
  }

  .v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)::v-deep fieldset {
    border-color: var(--v-resGrey-darken1) !important;
  }

  .list-group {
    width: 100%;
    height: 296px;
    overflow: auto;
    border: solid 1px #979797;
    background-color: #ffffff;
  }

  .v-list-item {
    width: 265px;
    height: 30px !important;
    min-height: 30px !important;
    margin: 10px;
    cursor: pointer;
    border: solid 1px #979797;
    background-color: #ffffff;
    &.active
  {
    background-color: #03739C;
    .v-list-item__title
  {
    color: #ffffff !important;
  }
    
  }
  }

    .no-items-message {
      border: 0px;
      width: 280px;
      height: 30px !important;
      min-height: 30px !important;
      margin: 10px;
      cursor: initial;
      background-color: #ffffff;
      font-style: italic;
    }

  .v-list-item__title {
    color: #03739c;
    font-size: 14px;
  }

  .two-list-container {
    width: 300px !important;
    max-width: 300px !important;
    min-width: 300px !important;
  }

  .select-remove-button, .select-add-button {
    background-color: var(--background-color) !important;
    border-color: var(--border-color) !important;
    border-radius: var(--border-radius);
    border-width: var(--border-width);
    margin: 5px 10px;
    span   {
    font-size: var(--font-size);
    color: var(--text-color) !important;
    font-family: roboto;
    letter-spacing: 0em;
  }

  .capitalize {
    text-transform: capitalize !important;
  }

  .v-icon {
    font-size: 12px;
    width: 8px;
  }
  }

  .select-remove-button.v-btn--disabled, .select-add-button.v-btn--disabled {
    color: var(--text-color-disabled) !important;
    span   {
    color: var(--text-color-disabled) !important;
  }
}

  .select-remove-button::v-deep .v-btn:before, .select-add-button::v-deep .v-btn:before {
    background-color: var(--background-color) !important;
  } 

  .select-add-button .btn-text {
    margin-right: 5px;
  }


  .select-all-container {
      height: 24px;
  }
  .select-all-button {
    color: #03739c;
  }
</style>

